import React, { Component, Fragment } from "react";
import Loader from "@bonprix/pattern-library/templates/loader/default";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "@bonprix/pattern-library/components/messages";

export default function DropdownContent({ disabled, children }) {
  const maxHeightDropdownContent = 324;
  const [isWithScrollbar, setIsWithScrollbar] = React.useState(false);
  const innerContent = React.useRef(null);
  const subs = React.useRef([]);

  const checkIfDropdownHasScrollbar = () => {
    return innerContent.current.offsetHeight > maxHeightDropdownContent;
  };

  const handleResize = () => {
    if (checkIfDropdownHasScrollbar() !== isWithScrollbar) {
      setIsWithScrollbar(!isWithScrollbar);
    }
  };

  React.useEffect(() => {
    setIsWithScrollbar(checkIfDropdownHasScrollbar());
    subs.current.push(
      MessageBroker.subscribe(Messages.WINDOW.RESIZED, handleResize)
    );

    return () => {
      subs.current.forEach((sub) => MessageBroker.unsubscribe(sub));
    };
  }, []);

  return (
    <div
      className={
        "dropdown__content-outer" + (disabled ? " -disabled" : "")
      }
      jsh-dropdown-content="true"
    >
      <div
        className={
          "dropdown__content-inner" +
          (isWithScrollbar ? " -is-with-scrollbar" : "")
        }
        jsh-dropdown-content-inner="true"
        ref={innerContent}
      >
        {disabled ? (
          <div className="dropdown__loader-wrapper">
            <Loader className="dropdown__loader" />
          </div>
        ) : (
          <></>
        )}
        {children}
      </div>
    </div>
  );
};
